module.exports = __webpack_public_path__ + "static/img/huayi_logo.74ee50c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/huayi_logo.png
// module id = 430
// module chunks = 1 2